import { CircularProgress } from '@mui/material';

export const Spinner = CircularProgress;
